import { Button } from "@mui/material";
import { EyeIcon } from "@phosphor-icons/react/dist/csr/Eye";
import { useAccountContext } from "../../strict/app/AccountResolver";
import { CompilationMessage, FlowSummary } from "../../graphql/types";
import { useNavigator } from "../../lib/Hooks";
import FlowSummaryIcon from "../common/FlowSummaryIcon";

const toErrorsWarnings = (messages: Array<CompilationMessage>) => {
  const error = messages.reduce((val, item) => val + (item.type === "error" ? 1 : 0), 0);
  const warning = messages.reduce((val, item) => val + (item.type === "warning" ? 1 : 0), 0);
  const beta = messages.reduce((val, item) => val + (item.type === "beta" ? 1 : 0), 0);
  return { error, warning, beta };
};

const ViewTestRunsButton = ({
  flowSummary,
  onClick,
}: {
  flowSummary?: FlowSummary | null;
  onClick?: (path?: string) => void;
}) => {
  const nav = useNavigator();

  const { urlName } = useAccountContext();
  const action = onClick
    ? () => onClick(`/app/${urlName}/scripts/tests`)
    : () => {
        nav.goto("scripts/tests");
      };
  return (
    <Button
      variant="outlined"
      size="small"
      endIcon={<FlowSummaryIcon flowSummary={flowSummary} />}
      startIcon={<EyeIcon />}
      onClick={() => action()}
    >
      Test Runs
    </Button>
  );
};

export { toErrorsWarnings, ViewTestRunsButton };
